<template>
  <!-- the #js-page-content id is needed for some plugins to initialize -->
  <main id="js-page-content" role="main" class="page-content" style="background:#dddae4">

      <div class="subheader" >
          <h1 class="subheader-title">
              <i class='subheader-icon fal fal fa-sync'></i> Procesos
          </h1>
      </div>
        <v-btn
          color="primary"
          width="140"
          @click="$router.push({name:'Process', params:{id:0}})">
          Crear Proceso
        </v-btn>

        <div>
            <div style="margin-bottom: 10px">
                <el-row>
                    <el-col :span="6">
                    <el-input placeholder="Buscar..." v-model="filters[0].value"></el-input>
                    </el-col>
                </el-row>
            </div>

            <data-tables :data="data" :action-col="actionCol" :filters="filters" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>

                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
                </el-table-column>
            </data-tables>
        </div>

  </main>
</template>


<script>
import Vue from 'vue';
import apiExtract from "@/api/modules/extract";
import store from '@/store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);
import { DataTables, DataTablesServer } from 'vue-data-tables'
Vue.use(DataTables)
Vue.use(DataTablesServer)



let organization_id = store.getters['auth/org'];

var data, titles

data = [];

titles = [{
  prop: "id",
  label: "ID"
  }, {
  prop: "text",
  label: "Proceso"
  }, {
  prop: "fecha_creacion",
  label: "Fecha Creación"
}]

export default {
  data() {
    return {
      data,
      titles,
      filters: [{
        prop: 'text',
        value: ''
      }],
      actionCol: {
        props: {
          label: 'Acción',
        },
        buttons: [{
          props: {
            type: 'primary'
          },
          handler: row => {
             this.$router.push('/process/'+row.id);
          },
          label: 'Editar'
        }]
      },
      selectedRow: []
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedRow = val
    },
  },
  mounted(){
      //llamando al api
      apiExtract.getProcesses(organization_id)
      .then((resp)=>{
          if(resp.status){
              this.data = resp.processes;
          }
      })
  }
}
</script>
